/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { BrowserRouter as Router, Route, HashRouter } from "react-router-dom";
import "./App.scss";

import MainContainer from "./containers/MainContainer/MainContainer";

import Header from "components/Header/Header";
import { connect } from "react-redux";
import { changeDevice } from "store/Layout/Layout.store";
import { reqNoticeList } from "store/Notice/Notice.store";

type Props = {
  changeDevice: (data: string) => any;
  noticeList: any;
  reqNoticeList: any;
  device: string;
  checkList: any;
};

function App({
  changeDevice,
  noticeList,
  reqNoticeList,
  device,
  checkList,
}: Props) {
  const [isMobile, setMobile] = React.useState(null);

  const ua = window.navigator.userAgent;
  React.useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      setMobile(true as never);
    } else {
      setMobile(false as never);
    }
  }, [ua]);

  React.useEffect(() => {
    if (typeof isMobile === "boolean" && !!isMobile) {
      if (
        navigator.userAgent.indexOf("Android") > 0 &&
        navigator.userAgent.indexOf("wv") > 0
      ) {
        changeDevice("AND");
      } else if (
        navigator.userAgent.indexOf("Mac OS") > 0 &&
        navigator.userAgent.indexOf("Safari") <= 0
      ) {
        changeDevice("ios");
      } else {
        changeDevice("browser");
      }
    } else if (typeof isMobile === "boolean" && !isMobile) {
      // 모바일이 아닐 때
      changeDevice("browser");
    }
  }, [isMobile]);

  React.useEffect(() => {
    if (
      !!device &&
      noticeList.length === 0 &&
      Object.keys(checkList).filter((item) => checkList[item] === false)
        .length === 0
    ) {
      reqNoticeList({
        poc: `${device !== "browser" ? `[${device}]` : ""}`,
      });
    } else {
      console.log({
        device: !!device,
        noticeLength: noticeList.length,
        checkList:
          Object.keys(checkList).filter((item) => checkList[item] === false)
            .length === 0,
      });
    }
  }, [device, noticeList, checkList]);

  return (
    <div className="App">
      {!isMobile && (
        <div id="header">
          <Header />
        </div>
      )}
      <div id="wrap" className={`${isMobile ? "mobile" : "desktop"}`}>
        {process.env.NODE_ENV !== "development" ? (
          <Router>
            <RoutesComponent />
          </Router>
        ) : (
          <HashRouter>
            <RoutesComponent />
          </HashRouter>
        )}
      </div>
    </div>
  );
}

const RoutesComponent = (props: any) => {
  return (
    <React.Fragment>
      {process.env.NODE_ENV === "development" ? (
        <Route exact path="/" component={MainContainer} props={props} />
      ) : (
        <Route exact path="/board" component={MainContainer} props={props} />
      )}

      {/* <Route exact path="/board/:id" component={DetailContainer} /> */}
    </React.Fragment>
  );
};

export default connect(
  ({ Notice, Layout }: { Notice: any; Layout: any }) => ({
    noticeList: Notice.noticeList,
    checkList: Notice.checkList,
    device: Layout.device,
  }),
  {
    reqNoticeList,
    changeDevice,
  }
)(App);
